import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

type BillingSection = 'usage' | 'history' | 'subscription' | 'payments';

function getActiveSection(pathname: string): BillingSection {
  const section = pathname.split('/')[2];
  if (section === 'history' || section === 'subscription' || section === 'payments') return section;
  return 'usage';
}

function isBillingSection(value: string): value is BillingSection {
  return value === 'usage' || value === 'history' || value === 'subscription' || value === 'payments';
}

export function BillingLayout() {
  const { t } = useTranslation('nav');
  const location = useLocation();
  const navigate = useNavigate();
  const activeSection = getActiveSection(location.pathname);
  const destinations: Record<BillingSection, string> = {
    usage: '/billing/usage',
    history: '/billing/history',
    subscription: '/billing/subscription',
    payments: '/billing/payments',
  };

  return (
    <div className="space-y-6">
      <Tabs value={activeSection} onValueChange={(value) => {
        if (isBillingSection(value)) navigate(destinations[value]);
      }}>
        <div className="max-w-full overflow-x-auto overflow-y-hidden">
          <TabsList className="w-max min-w-full justify-start">
            <TabsTrigger value="usage">{t('usage')}</TabsTrigger>
            <TabsTrigger value="history">{t('usageHistory')}</TabsTrigger>
            <TabsTrigger value="subscription">{t('subscription')}</TabsTrigger>
            <TabsTrigger value="payments">{t('purchaseHistory')}</TabsTrigger>
          </TabsList>
        </div>
      </Tabs>

      <Outlet />
    </div>
  );
}
